class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeHoverTimeout = null;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.mainDetailsToggle.querySelector('summary')?.addEventListener('click', this.navigateTopLevelOnDesktop.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnHover() {
    if (!this.hoverMediaQuery.matches) return;

    window.clearTimeout(this.closeHoverTimeout);

    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!this.hoverMediaQuery.matches) return;

    this.closeHoverTimeout = window.setTimeout(() => {
      this.close();
    }, 140);
  }

  navigateTopLevelOnDesktop(event) {
    if (!this.hoverMediaQuery.matches) return;

    const url = event.currentTarget.dataset.topLinkUrl;
    if (!url || url === '#') return;

    event.preventDefault();
    window.location.href = url;
  }
}

customElements.define('header-menu', HeaderMenu);
